import { useState } from "react";
import { FrontMeService } from "../service/client/FrontMeService";
import { errorToast } from "../toast";
import { TippingComment } from "interfaces/front/business";

// reduxが必要なやつ
export type MemberTippingCommentHelper = {
  tippingComment: TippingComment | null | undefined;
  loadIfNeeded: () => void;
  reload: () => void;
};
export const useMemberTippingComment = (
  slug: string
): MemberTippingCommentHelper => {
  const [tippingComment, setTippingComment] = useState<TippingComment | null>();
  const reload = async (): Promise<void> => {
    const service = new FrontMeService();
    await service.getTippingComment(
      slug,
      (comment) => setTippingComment(comment),
      () => {
        errorToast("アニエールのコメントが取得できませんでした。");
        setTippingComment(null);
      }
    );
  };
  const loadIfNeeded = async (): Promise<void> => {
    if (tippingComment === undefined) {
      await reload();
    }
  };
  return { tippingComment, loadIfNeeded, reload };
};
